import { BottleThumbnail } from './HierarchyMultiAddModal'
import { usableCardImage } from '../../lib/catalogSearchHouseFirst'

export default function BrowseLines({ lineGroups, activeLineName, activeHouse, toggleLine, alreadyOwned, renderBottle }) {
  return <>
    {lineGroups.map(group => (
      <section key={group.letter || 'all'} data-line-group={group.letter || undefined}>
        {group.letter && (
          <h4 className="sticky top-0 z-10 border-b border-white/10 bg-charcoal-800/95 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold backdrop-blur">
            {group.letter}
          </h4>
        )}
        {group.lines.map(line => {
          const expanded = activeLineName === line.name
          const ownedCount = line.variants.filter(variant => alreadyOwned(variant)).length
          const lineImage = line.variants.find(variant => usableCardImage(variant)) || null
          const panelId = `browse-line-${line.name.toLocaleLowerCase().replace(/[^a-z0-9]+/g, '-')}`
          return (
            <div key={line.name} className="border-b border-white/5 last:border-b-0" data-line-entry>
              <button
                data-list-key={line.name.toLocaleLowerCase()}
                data-line-row
                type="button"
                aria-expanded={expanded}
                aria-controls={panelId}
                onClick={() => toggleLine(line.name)}
                className={`flex min-h-16 w-full items-center gap-3 px-3 py-2 text-left transition-colors hover:bg-white/5 focus:bg-white/5 focus:outline-none ${expanded ? 'bg-gold/[0.06]' : ''}`}
              >
                <BottleThumbnail row={lineImage} size="line" />
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium text-cream">{line.name}</span>
                  <span className="text-[11px] text-cream/40">
                    {line.variants.length} bottle{line.variants.length === 1 ? '' : 's'}{ownedCount ? ` · ${ownedCount} owned` : ''}
                  </span>
                </span>
                <span className={`text-gold/70 transition-transform ${expanded ? 'rotate-90' : ''}`} aria-hidden>→</span>
              </button>

              {expanded && (
                <div id={panelId} role="group" aria-label={`${activeHouse} ${line.name} concentrations`} className="border-t border-gold/15 bg-black/10" data-visual-list="browse-concentration-results">
                  {line.variants.map(renderBottle)}
                </div>
              )}
            </div>
          )
        })}
      </section>
    ))}
  </>
}
